module.exports = __webpack_public_path__ + "static/img/project-moonbuggy.fff1194.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project-moonbuggy.png
// module id = UdaU
// module chunks = 0